import { type FeatureModule } from '@store/features/types';
import storage from 'redux-persist/lib/storage';

import auditUiReducer from './auditUiSlice';
import dismissalsReducer from './dismissalsSlice';

export const jotauditFeature: FeatureModule = {
  id: 'jotaudit',
  name: 'JotAudit',
  dependencies: [],
  reducers: {
    'jotaudit/ui': auditUiReducer,
    'jotaudit/dismissals': dismissalsReducer,
  },
  middleware: [],
  persistence: {
    enabled: true,
    storage: storage,
    whitelist: ['dismissedCardIds'], // Only persist dismissals
    debounce: 300, // Wait 300ms before saving to localStorage
  },
  sync: {
    enabled: true, // Sync dismissals across browser tabs
    whitelist: ['dismissCard', 'restoreCard'], // Sync these actions
  },
  setup: _store => {},
  cleanup: _store => {},
};

